export default __webpack_public_path__ + "static/media/79_desktop.49ebb149.jpg";